import React from 'react';

function ApplePay(props: object) {
  return (
    <svg
      width="51"
      height="21"
      viewBox="0 0 51 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.769 20.3626C44.3236 20.3626 45.5435 19.4242 46.5132 16.5881L50.6317 4.81641H47.8999L45.2411 13.7208H45.0639L42.3946 4.81641H39.5586L43.6354 16.2753L43.4999 16.7758C43.1662 17.8289 42.551 18.246 41.4562 18.246C41.279 18.246 40.8932 18.2355 40.7472 18.2043V20.3209C40.9141 20.3521 41.6126 20.3626 41.769 20.3626Z"
        fill="black"
      />
      <path
        d="M33.6059 14.3766C32.459 14.3766 31.6353 13.8031 31.6353 12.8439C31.6353 11.9159 32.313 11.3946 33.7623 11.3007L36.3377 11.1339V12.041C36.3377 13.3652 35.1699 14.3766 33.6059 14.3766ZM32.8448 16.4098C34.3358 16.4098 35.587 15.7633 36.223 14.6581H36.4003V16.2221H38.8922V8.43338C38.8922 6.01439 37.2448 4.58594 34.3149 4.58594C31.604 4.58594 29.7168 5.86842 29.5082 7.88076H31.9481C32.1879 7.10919 33.0012 6.69212 34.1898 6.69212C35.587 6.69212 36.3377 7.31772 36.3377 8.43338V9.39263L33.3974 9.56989C30.6239 9.73671 29.0703 10.9254 29.0703 12.9898C29.0703 15.0752 30.6447 16.4098 32.8448 16.4098Z"
        fill="black"
      />
      <path
        d="M17.4336 1.17969V16.2254H20.1237V11.2936H23.3872C26.4318 11.2936 28.5589 9.24993 28.5589 6.2679C28.5589 3.23374 26.5048 1.17969 23.5019 1.17969H17.4336ZM20.1237 3.43185H22.7929C24.7323 3.43185 25.8271 4.42238 25.8271 6.2679C25.8271 8.06129 24.701 9.06225 22.7825 9.06225H20.1237V3.43185Z"
        fill="black"
      />
      <path
        d="M9.66552 3.96213C8.42475 3.96213 7.42379 4.71285 6.77734 4.71285C6.0996 4.71285 5.19248 4.00384 4.11853 4.00384C2.07491 4.00384 0 5.70339 0 8.88352C0 10.875 0.771574 12.9708 1.7204 14.3367C2.52325 15.4732 3.24269 16.4116 4.26451 16.4116C5.27589 16.4116 5.72424 15.7443 6.98587 15.7443C8.25792 15.7443 8.54987 16.3907 9.66552 16.3907C10.7812 16.3907 11.5215 15.3793 12.2201 14.3784C12.9916 13.221 13.3253 12.0949 13.3357 12.0428C13.2732 12.0219 11.1461 11.1565 11.1461 8.71669C11.1461 6.61051 12.8144 5.67211 12.9082 5.59912C11.8134 4.00384 10.1347 3.96213 9.66552 3.96213ZM9.09206 2.61709C9.59254 2.00192 9.94704 1.16779 9.94704 0.323227C9.94704 0.208533 9.93662 0.09384 9.91576 0C9.10248 0.03128 8.10152 0.542187 7.5072 1.24077C7.04843 1.77253 6.61051 2.61709 6.61051 3.46165C6.61051 3.58677 6.63136 3.72232 6.64179 3.76403C6.69392 3.77445 6.77734 3.78488 6.86075 3.78488C7.60104 3.78488 8.53944 3.2844 9.09206 2.61709Z"
        fill="black"
      />
    </svg>
  );
}

export default ApplePay;
